import { InjectionToken } from '@angular/core';

export const XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT = new InjectionToken<number>('xpoGridBoardDefaultRowHeight');
